import { useEffect, useState } from 'react'
import Calendar from './Calendar'
import { shortDate } from '../lib/dates'

// Compact date button that opens a modal with the Calendar inside.
// Replaces the previous inline full-width calendar in the Order form.
export default function DateInput({
  label,
  placeholder = 'Pick a date',
  selected,
  onSelect,
  minDate,
  maxDate,
  accent = 'aqua',
}) {
  const [open, setOpen] = useState(false)

  // Close on Escape.
  useEffect(() => {
    if (!open) return
    const onKey = (e) => e.key === 'Escape' && setOpen(false)
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open])

  // Lock body scroll while the modal is open.
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [open])

  const accentBorder = accent === 'green' ? 'border-green' : 'border-aqua'
  const accentText = accent === 'green' ? 'text-green' : 'text-aqua'

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`flex w-full items-center justify-between rounded-lg border-[1.5px] bg-white px-3 py-2.5 text-left transition ${
          selected ? accentBorder : 'border-line'
        }`}
      >
        <span className={`text-[13px] font-bold ${selected ? 'text-navy' : 'text-ink-3'}`}>
          {selected ? shortDate(selected) : placeholder}
        </span>
        <span className={`text-[11px] font-extrabold ${accentText}`}>
          {selected ? 'Change' : 'Pick'}
        </span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 px-3 pb-4 pt-6 sm:items-center sm:pb-6"
          onClick={() => setOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label={label || 'Pick a date'}
        >
          <div
            className="w-full max-w-xs rounded-2xl bg-white p-3 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-2 flex items-center justify-between px-1">
              <div className="font-bricolage text-[13px] font-extrabold text-navy">
                {label || 'Pick a date'}
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="Close"
                className="text-ink-3 hover:text-ink"
              >
                ✕
              </button>
            </div>
            <Calendar
              selected={selected}
              minDate={minDate}
              maxDate={maxDate}
              accent={accent}
              onSelect={(iso) => {
                onSelect(iso)
                setOpen(false)
              }}
            />
          </div>
        </div>
      )}
    </>
  )
}
